import React, {useEffect, useRef, useState} from 'react';
import apiJSON from "../../../api/apiJSON";
import gsap from "gsap";
import Button from "../../ui/Button/Button";
import "./SpeechEntry.sass"
import {getSpaceUntilMaxLength} from "@testing-library/user-event/dist/utils";
import renderHTML from "react-render-html";

const SpeechEntry = ({data, completed, next}) => {

    const [showFeedback, setShowFeedback] = useState(false);
    const [transitionComplete, setTransitionComplete] = useState(false);
    const [entry, setEntry] = useState(null);
    const jsonData = apiJSON.get(data);
    const scenario = jsonData.scenario;
    const {choiceSet} = scenario;
    const textArea = useRef(null);

    useEffect(() => {
        gsap.from(".speech-entry-main-balloon", {x: 1400, ease: "expo.out", delay: 1, opacity: 0, duration: 2});
        gsap.set("#title1", {opacity: 1})
        gsap.from(["#title1", ".speech-entry-input-balloon"], {
            x: 1600,
            ease: "expo.out",
            delay: 3,
            opacity: 0,
            duration: 2
        });
        setTransitionComplete(false);
    }, []);

    useEffect(() => {
        gsap.set(["#title2", ".speech-entry-feedback-balloon"], {opacity: 1});
        gsap.from(["#title2", ".speech-entry-feedback-balloon"], {x: 1600, ease: "expo.out", opacity: 0, duration: 1});
    }, [showFeedback]);

    useEffect(() => {
        console.log("useEfect entry updated")
    }, [entry]);

    const updateEntry = () => {
        setEntry(textArea.current.value);
    }

    const focusTextArea = () => {
        console.log("SpeechEntry focusTextArea(",entry,")");
        if(!entry){
            textArea.current.value="";
        }
    }

    const handleContinue = () => {
        completed();
        setShowFeedback(true);
    }

    const handleDone = () => {
        next();
    }

    return (
        <div className="SpeechEntry">
            <div className="speech-entry-image">
                <img src={scenario.image.url}
                     style={scenario.image.style ? scenario.image.style : {}}/>
            </div>
            <div className="speech-entry-balloon-panel">
                <div className="speech-entry-main-balloon">
                    {choiceSet.choices[0].label}
                </div>

                <div className="speech-entry-input-balloon">
                    <div className="speech-entry-balloon-panel-title"
                         id="title1">
                        {scenario.title}
                    </div>
                    <textarea
                        ref={textArea}
                        className="speech-entry-input-balloon-textarea"
                        value={(!entry ? scenario.body : entry)}
                        onChange={updateEntry}
                        onFocus={focusTextArea}>

                    </textarea>
                    {
                        !showFeedback &&
                        <Button data={"Continue"}
                                callback={handleContinue}
                                disabled={(!entry)}
                                style={{
                                    "marginLeft": "auto"
                                }}/>
                    }

                </div>

                {showFeedback &&
                <div className="speech-entry-feedback-balloon">
                    <div className="speech-entry-balloon-panel-title"
                         id="title2">
                        {choiceSet.choices[0].feedback.title}
                    </div>
                    {choiceSet.choices[0].feedback.body}
                    <Button data={"Continue"}
                            callback={handleDone}
                            style={{
                                "marginLeft": "auto"
                            }}/>
                </div>
                }

            </div>

        </div>
    );
};

export default SpeechEntry;